<template>
    <div class="vue-tempalte">
        <div class="container mt-5 mb-5">
            <div class="row justify-content-center">
                <div class="col-md-8">
                    <div v-if="isUploaded" class="alert alert-success" role="alert">
                        Успешно добавена снимка!
                    </div>
                    <form ref="serviceForm" @submit.prevent="onFormSubmit">
                        <h3>Добави снимка</h3>

                        <div class="form-group">
                            <label>Снимка</label>
                            <input type="file" class="form-control form-control-lg"  ref="file" v-on:change="handleFileUpload()" required multiple>
                        </div>

                        <div class="form-group">
                            <button :disabled="!gallery.image" class="btn btn-primary btn-block">Запази</button>
                            <a :href="`${publicPath}ceni-2020.pdf`" target="_blank">PDF</a>
                        </div>
                    </form>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import { db } from '../../firebase';

    export default {

        data() {
            return {
                gallery: {
                    image: '',
                    createdAt: Date.now()
                },
                isUploaded: false
            }
        },
        methods: {
            onFormSubmit(event) {
                event.preventDefault();
                db.collection('gallery').add(this.gallery).then(() => {
                    this.isUploaded = true;
                    this.$refs.file.value = null;
                    this.gallery.image = null;
                    setTimeout(()=>{
                        this.isUploaded = false;
                    },2000);

                }).catch((error) => {
                    console.log(error);
                });
            },

            handleFileUpload(){
                const reader = new FileReader();
                reader.readAsDataURL(this.$refs.file.files[0]);
                reader.onload = ()=> {
                    this.gallery.image = reader.result;
                };
            }
        }
    }
</script>
